const getters = {
  systemName: state => state.app.systemName,
  personalMsg: state => state.app.personalMsg
};
export default getters;
